import React, { Component } from 'react';
import { Button } from 'antd';
import { CheckCircleOutlined } from '@ant-design/icons';
import CpLogo from '../../components/CpLogo';
import CpSteps from '../../components/CpSteps';
import { connect } from 'react-redux';
import { initShopCart } from '../../store/actions/shopCartActions';
import { initPlanList } from '../../store/actions/planListActions';
import './style.less';

const stepConfig = {
  '1': [
    { name: '我的购物车', status: 2 },
    { name: '核对订单信息', status: 2 },
    { name: '成功提交订单', status: 1 }
  ],
  '2': [
    { name: '我的计划单', status: 2 },
    { name: '核对计划单信息', status: 2 },
    { name: '成功提交计划单', status: 1 }
  ],
  '3': [//订货单
    { name: '我的订货单', status: 2 },
    { name: '核对订单单信息', status: 2 },
    { name: '成功提交订货单', status: 1 }
  ],
  '4': [//询价单
    { name: '我的询价单', status: 2 },
    { name: '核对询价单信息', status: 1 },
    { name: '成功提交询价单', status: 0 }
  ],
  '5': [
    { name: '我的购物车', status: 2 },
    { name: '核对订单信息', status: 2 },
    { name: '成功提交订单', status: 1 }
  ],
};
const titleOptions = {
  1: '您的订单已提交成功',
  2: '您的计划单已提交成功',
  3: '您的订货单已提交成功',
  4: '您的询价单已提交成功',
  5: '您的订单已提交成功',
};

class SubmitOrderResult extends Component {
  constructor(props) {
    super(props);
    this.type = Number(this.props.match.params.type);
  }

  componentDidMount() {
    const { initShopCart, initPlanList } = this.props;
    this.type === 1 ? initShopCart() : initPlanList();
  }
  componentWillUnmount() {
    this.setState = () => false;
  }
  confirm = () => {
    if (this.type === 4) {
      this.props.history.push('/basic/user/enquiryOrder');
    } else if (this.type === 3) {
      this.props.history.push('/basic/user/proposalList');
    } else if (this.type === 1 || this.type === 5) {
      this.props.history.push('/basic/user/order');
    } else {
      this.props.history.push('/basic/user/planOrder');
    }
  }

  render() {
    const type = this.type;
    let stepArray = stepConfig[type];

    let header = (
      <div className="submit-order-top">
        <CpLogo />
        <div className="steps">
          <CpSteps current={2} steps={stepArray} />
        </div>
      </div>
    );

    return (
      <div className="submit-order-result">
        {header}
        <div className="result-info">
          <div className="result-info-content">
            <CheckCircleOutlined className="success-icon" />
            <div className="success-text">{titleOptions[type]}</div>
            <Button className="success-btn" onClick={this.confirm}>确定</Button>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    initShopCart: () => {
      dispatch(initShopCart());
    },
    initPlanList: () => {
      dispatch(initPlanList());
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SubmitOrderResult);